import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { ResetPasswordForm } from '../components/forms/ResetPasswordForm';

export const ResetPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return (
      <AuthLayout
        title={t('auth.resetPassword.error.title')}
        subtitle={t('auth.resetPassword.error.message')}
      >
        <div className="text-center">
          <div className="bg-error-50 rounded-xl p-6">
            <p className="text-error-700">
              {t('auth.resetPassword.error.message')}
            </p>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title={t('auth.resetPassword.title')}
      subtitle={t('auth.resetPassword.subtitle')}
    >
      <ResetPasswordForm />
    </AuthLayout>
  );
};
